import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCwz0LBqYuoqpYG3pB6BuASQ8ncQli_oK8",
  authDomain: "ecommerce-c0b4f.firebaseapp.com",
  projectId: "ecommerce-c0b4f",
  storageBucket: "ecommerce-c0b4f.firebasestorage.app",
  messagingSenderId: "237773181961",
  appId: "1:237773181961:web:d217f8641cbf42bd9d94d8",
  measurementId: "G-KSC8CGTG64"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app; 